import React, { useState } from 'react';
import { initialState } from './initialState';

export const AppContext = React.createContext();

export const AppProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(initialState.user);
  const [activeKosning, setActiveKosning] = useState(initialState.activeKosning);
  const [atkvaediOptions] = useState(initialState.atkvaediOptions);
  const [drawer, setDrawer] = useState(initialState.drawer);

  const store = {
    isLoggedIn: { get: isLoggedIn, set: setIsLoggedIn },
    user: { get: user, set: setUser },
    activeKosning: { get: activeKosning, set: setActiveKosning },
    atkvaediOptions: { get: atkvaediOptions }, 
    drawer: { get: drawer, set: setDrawer },
  };

  return (
    <AppContext.Provider value={store}>
      {props.children}
    </AppContext.Provider>
  );
};